import { Star } from "lucide-react";
import Reveal from "./Reveal";
import SectionHeader from "./SectionHeader";
import { useLanguage } from "../context/LanguageContext";
import { BUSINESS } from "../data/siteConfig";

const initials = (name) =>
  name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("");

const Stars = ({ size = "h-4 w-4" }) => (
  <div className="flex gap-0.5" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className={`${size} fill-bronze text-bronze`} />
    ))}
  </div>
);

const Reviews = () => {
  const { t } = useLanguage();

  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <SectionHeader
              eyebrow={t.reviews.eyebrow}
              heading={t.reviews.heading}
              sub={t.reviews.note}
            />
          </div>
          <Reveal className="lg:col-span-5" delay={0.15}>
            <div
              data-testid="google-rating-summary"
              className="flex items-center gap-6 rounded-2xl border border-line bg-sand p-8"
            >
              <span className="font-head text-6xl leading-none text-ink">
                {BUSINESS.google.rating}
              </span>
              <div className="flex flex-col gap-2">
                <Stars size="h-5 w-5" />
                <p className="text-sm text-taupe">
                  {BUSINESS.google.reviewCount} {t.reviews.reviewsWord} · Google
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-3">
          {BUSINESS.reviews.map((review, i) => (
            <Reveal key={review.name} delay={i * 0.12}>
              <article
                data-testid={`review-card-${i + 1}`}
                className="flex h-full flex-col gap-6 rounded-2xl border border-line bg-white p-8 shadow-[0_8px_30px_rgba(28,27,26,0.04)] transition-[box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_rgba(28,27,26,0.09)]"
              >
                <div className="flex items-center justify-between">
                  <Stars />
                  <span className="rounded-full bg-sand px-3 py-1 text-xs font-semibold text-bronze-dark">
                    {t.reviews.cardLabel}
                  </span>
                </div>
                {review.text && (
                  <blockquote className="text-sm md:text-base leading-relaxed text-ink/80">
                    “{review.text}”
                  </blockquote>
                )}
                <div className="mt-auto flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-full bg-bronze/15 font-head text-lg text-bronze-dark">
                    {initials(review.name)}
                  </span>
                  <div>
                    <p className="font-semibold text-ink">{review.name}</p>
                    <p className="text-xs text-taupe">Google</p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
